import { useState } from 'react'
import {
  Anchor,
  Button,
  H2,
  Paragraph,
  Separator,
  Spinner,
  XStack,
  YStack,
  useWindowDimensions,
} from '@my/ui'
import { ChatDemo } from './chat'
import { TZAApiClient, useAuthedRequestFn, useLink } from '@my/util'
import { useQuery } from '@tanstack/react-query'
import { useUser } from '@clerk/react'

export function ChatDemoScreen() {
  const { height, width } = useWindowDimensions()
  const { user } = useUser()
  //const link = useLink('/')
  const authedRequestFn = useAuthedRequestFn()
  /* const reviewDataQuery = useQuery({ 
        queryKey: ['financial-review'], 
        queryFn: () => authedOfetch('/financial-review')
    }); */
  const [messages, setMessages] = useState<
    {
      message: string
      itsMe: boolean
      time: number
      avatar?: string
    }[]
  >([])

  const onChatInput = async (message: string) => {
    if (message && message.length) {
      const newMessage = {
        message,
        itsMe: true,
        time: new Date().valueOf(),
        avatar: user?.imageUrl || undefined,
      }
      const newMessages = [...messages, newMessage]
      setMessages(newMessages)
      const chatRes = await TZAApiClient.chat(
        newMessages.map((msg) => msg.message),
        { authedRequestFn }
      )

      setMessages((prev) => [
        ...prev,
        {
          message: chatRes.systemResponse,
          itsMe: false,
          time: new Date().valueOf(),
          avatar: 'https://app.thezillennialadvisors.com/assets/favicon-180x180-Bsc24I8e.png',
        },
      ])
    }
  }

  const chat = true ? (
    <ChatDemo messages={messages as any} pushMessage={onChatInput} />
  ) : (
    <Spinner size="large" color="$green10" />
  )
  return (
    <YStack f={1} justifyContent="center" alignItems="center" p="$4" space height={height - 90}>
      <YStack space="$4" bc="$background">
        {/* <H1 ta="center">The Zillennial Advisor</H1> */}
        <H2 ta="center">Chat Demo</H2>
      </YStack>

      {chat}
    </YStack>
  )
}
